export default {
    environment:"production",//
    development_api:"http://127.0.0.1:5000",
    production_api:"https://estimator-api.topflightapps.com",
    development_api_key:"xxx",
    production_api_key:"TF1562126981957"
}